import { render } from "./assets-categories.vue?vue&type=template&id=0e6b79f6"
import script from "./assets-categories.vue?vue&type=script&lang=js"
export * from "./assets-categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__